export default "__VITE_ASSET__sZjUh3Zh__"